import { IOfferLand, EAreaUnitType } from 'shared/types/offers';

export const getTotalArea = (totalArea?: number): string | null => {
  if (totalArea) {
    return String(Math.round(totalArea));
  }

  return null;
};

export const getRoomArea = (roomArea?: number): string | null => {
  if (roomArea) {
    return `${Math.round(roomArea)}`;
  }

  return null;
};

export const getLivingArea = (livingArea?: number): string | null => {
  if (livingArea) {
    return `жилая ${Math.round(livingArea)}`;
  }

  return null;
};

export const getKitchenArea = (kitchenArea?: number): string | null => {
  if (kitchenArea) {
    return `кухня ${Math.round(kitchenArea)}`;
  }

  return null;
};

export const getLandArea = (land?: IOfferLand) => {
  if (land && land.area) {
    const unitTypes: { [K in EAreaUnitType]: string } = {
      hectare: 'га',
      sotka: 'сот.',
    };

    return `${Number(land.area)} ${(land.areaUnitType && unitTypes[land.areaUnitType]) || 'сот.'}`;
  }

  return undefined;
};

export const getMinArea = (minArea?: number): string | undefined => {
  return minArea ? `${minArea}`.split('.')[0] : undefined;
};

export const getWithSquareMeters = (data?: string | number): string => (data ? `${data} м\u00B2` : '');
